import { FC } from 'react';

import { changeMode, getQuestionAsync } from '../questionSlice';

import { GenericList } from '../../../shared/components/GenericList/GenericList';
import { ModeEnum, StatusEnum } from '../../../shared/models/Enums';
import { EditQuestionData } from '../models/EditQuestionData';
import { ResourcesService } from '../../../shared/services/ResourcesService';
import { useAppSelector } from '../../../app/hooks';
import { selectUserLanguage } from '../../login/loginSlice';

type QuestionsListProps = {
    questions: EditQuestionData[],
    questionStatus: StatusEnum,
    dispatch: Function
    loadQuestionEdit: Function,
    query: string
    setQuery: Function,
    onNext: Function,
    onPrevious: Function,
};

export const QuestionsList: FC<QuestionsListProps> = ({
    questions, questionStatus, dispatch, loadQuestionEdit, query, setQuery, onNext, onPrevious
}) => {
    const lang = useAppSelector(selectUserLanguage);
    const tableHeaders = ['#', ResourcesService.translate('Title', lang), ResourcesService.translate('Subtitle', lang), ResourcesService.translate('Type', lang)];

    return (
        <GenericList
            lang={lang}
            h2={ResourcesService.translate('Questions', lang)}
            headContent={
                <tr>
                    {
                        tableHeaders.map(h => <th key={h}>{h}</th>)
                    }
                </tr>
            }
            bodyContent={
                questions.map((d, i) =>
                    <tr key={i} onClick={() => dispatch(getQuestionAsync(d.id))}>
                        <td>{d.id.substring(0, 8)}...</td>
                        <td>{ResourcesService.translateInput(d.title, d.titleEn, d.titleThird, lang)}</td>
                        <td>{ResourcesService.translateInput(d.subtitle, d.subtitleEn, d.subtitleThird, lang)}</td>
                        <td>{d.type}</td>
                    </tr>
                )
            }
            listStatus={questionStatus}
            numberOfRows={5}
            numberOfColumns={tableHeaders.length}
            onCreateClick={() => dispatch(changeMode(ModeEnum.Create))}
            searchValue={query}
            onSearch={(value: string) => dispatch(setQuery(value))}
            onNext={() => dispatch(onNext())}
            onPrevious={() => dispatch(onPrevious())}
        />
    );
}